module.exports = __webpack_public_path__ + "static/media/retail-new-format.9523cf28.svg";